(()=>{
  'use strict';
  const root=document.documentElement;
  if(root.dataset.bfxLoaded==='true')return;
  root.dataset.bfxLoaded='true';
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const precise=window.matchMedia('(hover: hover) and (pointer: fine)');
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const decorate=(parent,className,prepend=false)=>{
    if(!parent)return null;
    let el=parent.querySelector(':scope > .'+className);
    if(el)return el;
    el=document.createElement('span');
    el.className=className;
    el.setAttribute('aria-hidden','true');
    if(prepend)parent.prepend(el);else parent.append(el);
    return el;
  };
  const pointerField=(element,{x='--bfx-x',y='--bfx-y',amplitude=0,tiltTarget=null}={})=>{
    if(!element)return;
    let frame=0,point=null;
    const update=()=>{
      frame=0;
      if(!point)return;
      const r=element.getBoundingClientRect();
      if(r.width<2||r.height<2)return;
      const px=clamp((point.clientX-r.left)/r.width,0,1);
      const py=clamp((point.clientY-r.top)/r.height,0,1);
      element.style.setProperty(x,(px*100).toFixed(2)+'%');
      element.style.setProperty(y,(py*100).toFixed(2)+'%');
      if(tiltTarget&&amplitude>0){
        tiltTarget.style.setProperty('--bfx-tilt-x',((px-.5)*amplitude).toFixed(2)+'px');
        tiltTarget.style.setProperty('--bfx-tilt-y',((py-.5)*amplitude*.66).toFixed(2)+'px');
      }
    };
    element.addEventListener('pointermove',event=>{
      if(motion.matches||!precise.matches||document.hidden||event.pointerType==='touch')return;
      point={clientX:event.clientX,clientY:event.clientY};
      if(!frame)frame=window.requestAnimationFrame(update);
    },{passive:true});
    element.addEventListener('pointerleave',()=>{
      if(frame){window.cancelAnimationFrame(frame);frame=0;}
      point=null;
      element.style.removeProperty(x);
      element.style.removeProperty(y);
      if(tiltTarget){tiltTarget.style.removeProperty('--bfx-tilt-x');tiltTarget.style.removeProperty('--bfx-tilt-y');}
    },{passive:true});
  };
  const init=()=>{
    root.classList.add('bfx-ready');
    const intro=document.querySelector('.v17-premiere[data-v8-opening]');
    if(intro){
      const stage=intro.querySelector('.v17-premiere__stage');
      const holder=intro.querySelector('.v17-premiere__watch-holder');
      if(stage){decorate(stage,'bfx-intro-aura',true);decorate(stage,'bfx-intro-diagonal',true);pointerField(stage,{amplitude:9,tiltTarget:holder});}
    }
    const hero=document.querySelector('.v13-hero');
    if(hero){
      const object=hero.querySelector('.v13-hero__object');
      if(object){decorate(object,'bfx-hero-aura',true);pointerField(object);}
    }
    const chamber=document.querySelector('.v9-chamber');
    if(chamber){
      const scene=chamber.querySelector('.v9-chamber__scene');
      if(scene){decorate(scene,'bfx-chamber-aura',true);pointerField(scene);}
      if('IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{entry.target.classList.toggle('bfx-in-view',entry.isIntersecting);if(entry.isIntersecting&&entry.intersectionRatio>=.12)entry.target.classList.add('bfx-ritual');});
        },{rootMargin:'0px 0px -11% 0px',threshold:.12});
        observer.observe(chamber);
      }else chamber.classList.add('bfx-in-view');
    }
    const photo=document.querySelector('.bh-pdp__photo');
    if(photo){decorate(photo,'bfx-photo-aura',true);pointerField(photo);}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
